import React, { Component } from 'react'
import { MenuItem, Menu, Button, Icon, Grid } from '@material-ui/core'
import { EditableTextField } from '../../components/common/EditableComponents'
import { canCreateOrEditMasterCategory, canCreateOrEditMasterProduct } from '../../utils/api'
import { ModalAddLocationConnect } from './ModalAddLocation'
import { openErrorMessage } from '../../actions/message'
import ModalAdoptionMode from './ModalAdoptionMode'
import { connect } from 'react-redux'
import { setAdoptionModeMasterProducts } from '../../actions/masterCatalog'
import ModalVerifyAdoptionMode from './ModalVerifyAdoptionMode'
import { ModalReviewDataAdoptionModeConnect } from './Fields/ModalReviewDataAdoptionMode'
import ModalValidateProductsAdoptionMode from './ModalValidateProductsAdoptionMode'
import { EditableReactSelect } from '../common/EditableComponents'
import { setFilterOption } from '../../actions/masterCatalog'
import ModalMcImportProducts from './Modals/ModalMcImportProducts'
import { statusFilterOptions } from '../../utils/catalog/catalog'
import { updateProperties as bulkUpdateProductOptions } from '../../utils/catalog/masterProduct'
import { updateProperties as bulkUpdateCategoryOptions } from '../../utils/catalog/masterCategory'

class SearchBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      anchorEl: null,
      showModalImport: false,
      modalToAddLocation: false,
      modalAdoptionMode: false,
      modalVerifyAdoptionMode: false,
      modalReviewAdoptionMode: false,
      modalValidateProductsAdoptionMode: false,
    }
  }

  openModalToAddLocation = () => {
    this.setState({
      modalToAddLocation: true,
    })
  }

  handleOpenMenu = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    })
  }

  handleClose = () => {
    this.setState({
      anchorEl: null,
    })
  }

  bulkUpdate = (option) => {
    this.handleClose()
    this.props.bulkUpdate(option)
  }

  closeModalAddLocation = (update = false) => {
    this.setState({
      modalToAddLocation: false,
    })

    if (update) {
      this.props.processOnGrid([])
    }
  }

  openModalAdoptionMode = () => {
    const {
      buttonText,
      selectedProducts = [],
      selectedCategories = [],
      typeProduct = '',
      typeCategory = '',
      selectedProductType = '',
      selectedCategoryType = '',
    } = this.props

    if (buttonText == 'New Product') {
      if (selectedProducts.length > 1 && typeProduct == 'master' && selectedProductType == 'parent')
        return this.props.dispatch(
          openErrorMessage('Only one master product can be selected at a time to adoption.'),
        )

      if (selectedProductType == 'child')
        return this.props.dispatch(openErrorMessage("Child product can't use adoption mode"))
    }

    if (buttonText == 'New Category') {
      if (
        selectedCategories.length > 1 &&
        typeCategory == 'master' &&
        selectedCategoryType == 'parent'
      )
        return this.props.dispatch(
          openErrorMessage('Only one master category can be selected at a time to adoption.'),
        )

      if (selectedCategoryType == 'child')
        return this.props.dispatch(openErrorMessage("Child category can't use adoption mode"))
    }

    this.setState({ modalAdoptionMode: true })
  }

  handleCloseAdoptionMode = () => {
    this.setState({ modalAdoptionMode: false })
  }

  // Save in redux the Adoption Mode as true
  activeAdoptionMode = () => {
    this.props.dispatch(setAdoptionModeMasterProducts(true))
    this.props.processOnGrid([])
    this.props.dispatch(setFilterOption([]))
    this.props.handleAdoptionMode && this.props.handleAdoptionMode()
    this.handleCloseAdoptionMode()
  }

  exitAdoptionMode = () => {
    this.deactivateAdoptionMode()
    this.props.closeEverything(true)
  }

  deactivateAdoptionMode = () => {
    this.props.dispatch(setAdoptionModeMasterProducts(false))
    this.props.deactivateAdoptionMode && this.props.deactivateAdoptionMode()
  }

  // Take the first item and open the next modal
  handleContinueAdoptionMode = () => {
    const { selectedProducts = [], selectedCategories = [], typeProduct, typeCategory } = this.props

    var item
    if (this.props.buttonText == 'New Product') {
      item = selectedProducts.length > 0 ? selectedProducts[0] : null
    } else {
      item = selectedCategories.length > 0 ? selectedCategories[0] : null
    }

    if (item) {
      if (this.props.buttonText == 'New Product') {
        if (typeProduct === 'master') {
          this.props.onProductTypeChange('orphan')
          this.props.saveParentProduct(item)
          return
        }
      }
      if (this.props.buttonText == 'New Category') {
        if (typeCategory === 'master') {
          this.props.handleCategoryFilterChange('orphan')
          this.props.saveParentCategory(item)
          return
        }
      }
      this.setState({ modalReviewAdoptionMode: true })
    } else {
      this.setState({ modalValidateProductsAdoptionMode: true })
    }
  }

  handleCloseVerifyAdoptionMode = () => {
    this.setState({
      modalVerifyAdoptionMode: false,
    })
  }

  handleCloseReviewAdoptionMode = (update = false) => {
    this.setState({
      modalReviewAdoptionMode: false,
    })
    if (update) {
      this.deactivateAdoptionMode()
      this.props.closeEverything(update)
    }
  }

  handleCloseValidateAdoptionMode = () => {
    this.setState({
      modalValidateProductsAdoptionMode: false,
    })
  }

  handleContinueVerifyAdoptionMode = () => {
    this.setState({
      modalReviewAdoptionMode: true,
      modalVerifyAdoptionMode: false,
    })
  }

  render() {
    const {
      buttonText,
      openModal,
      masterCatalogReducer,
      selectedProducts,
      selectedCategories,
      selectedParentProduct,
      selectedParentCategory,
      filter,
    } = this.props

    const {
      anchorEl,
      showModalImport,
      modalToAddLocation,
      modalAdoptionMode,
      modalVerifyAdoptionMode,
      modalReviewAdoptionMode,
      modalValidateProductsAdoptionMode,
    } = this.state

    const open = Boolean(anchorEl)
    const canEdit =
      buttonText == 'New Product' ? canCreateOrEditMasterProduct() : canCreateOrEditMasterCategory()

    const allBulkUpdateOptions =
      buttonText === 'New Product' ? bulkUpdateProductOptions : bulkUpdateCategoryOptions
    const bulkUpdateOptions = allBulkUpdateOptions
      .filter((option) => option.bulkOption)
      .map((option) => {
        return option.field == 'active' ? { ...option, name: 'Status' } : option
      })
      .sort((a, b) => a.name.localeCompare(b.name))

    const adoptionMode = masterCatalogReducer.adoptionMode || false

    return (
      <div className="search-bar-container">
        {
          <Grid
            container
            spacing={8}
            style={{ fontSize: '13px', fontWeight: 400, fontFamily: 'Roboco' }}
          >
          <Grid item xs={6} lg={2}>
            <EditableTextField
              placeholder="Search"
              material={false}
              value={this.props.term}
              onChange={this.props.handleTermChange}
              editMode
              style={{ flexDirection: 'row', height: '34px', backgroundColor: 'white' }}
            />
          </Grid>
            <Grid item xs={6} lg={3}>
              <EditableReactSelect
                className=""
                name="filter"
                placeholder="Filter"
                options={statusFilterOptions}
                valueToRender={statusFilterOptions.map((option) => option.value).join(', ')}
                value={filter}
                onChange={this.props.handleFilterChange}
                type="text"
                InputLabelProps={{
                  shrink: true,
                }}
                multi
                editMode
              />
            </Grid>
            {!!canEdit && !adoptionMode && (
              <Grid item xs={12} lg={7} style={{ display: 'flex', justifyContent: 'end'}}>
                {buttonText == 'New Product' && (
                  <Button
                    className="button-white-and-blue"
                    onClick={() => {
                      this.setState({ showModalImport: true })
                    }}
                  >
                    <Icon color="primary">file_upload</Icon>
                    <span className="button-text"> Import </span>
                  </Button>
                )}
                <Button
                  aria-owns={open ? 'render-props-menu' : null}
                  aria-haspopup="true"
                  className="button-white-and-blue"
                  onClick={this.handleOpenMenu}
                >
                  <Icon color="primary">app_registration</Icon>
                  <span className="button-text">Bulk Update</span>
                </Button>
                <Menu
                  id="render-props-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={this.handleClose}
                >
                  {bulkUpdateOptions.map((option, i) => {
                    return (
                      <MenuItem
                        key={i}
                        onClick={() => this.bulkUpdate(option)}
                        value={option.field}
                      >
                        {option.name}
                      </MenuItem>
                    )
                  })}
                </Menu>
                <Button
                  aria-owns={open ? 'render-props-menu' : null}
                  aria-haspopup="true"
                  className="button-white-and-blue"
                  onClick={this.openModalAdoptionMode}
                >
                  <span className="button-text">Adopt Mode</span>
                </Button>
                {buttonText == 'New Product' && (
                  <Button
                    aria-owns={open ? 'render-props-menu' : null}
                    aria-haspopup="true"
                    className="button-white-and-blue"
                    onClick={this.openModalToAddLocation}
                  >
                    <span className="button-text">Add to Location</span>
                  </Button>
                )}
                <Button
                  variant="contained"
                  className="button-blue-and-white"
                  onClick={() => {
                    openModal && openModal(true)
                  }}
                >
                  <span className="button-text">{buttonText}</span>
                </Button>
              </Grid>
            )}
            {adoptionMode && (
              <Grid item xs={12} lg={7} style={{ display: 'flex', justifyContent: 'end' }}>
                <Button
                  onClick={this.exitAdoptionMode}
                  className="button-white-and-red"
                  style={{ marginRight: '10px' }}
                >
                  <span className="button-text">Exit Adoption Mode</span>
                </Button>
                <Button onClick={this.handleContinueAdoptionMode} className="button-blue-and-white">
                  <span className="button-text">Continue</span>
                </Button>
              </Grid>
            )}
          </Grid>
        }

        {showModalImport && (
          <ModalMcImportProducts
            open={showModalImport}
            closeModal={() => {
              this.setState({ showModalImport: false })
            }}
            dispatch={this.props.dispatch}
          />
        )}
        {modalToAddLocation && (
          <ModalAddLocationConnect
            open={modalToAddLocation}
            closeModal={this.closeModalAddLocation}
          />
        )}
        {modalAdoptionMode && (
          <ModalAdoptionMode
            open={modalAdoptionMode}
            activeAdoptionMode={this.activeAdoptionMode}
            close={this.handleCloseAdoptionMode}
          />
        )}
        {modalVerifyAdoptionMode && (
          <ModalVerifyAdoptionMode
            open={modalVerifyAdoptionMode}
            close={this.handleCloseVerifyAdoptionMode}
            handleContinueVerifyAdoptionMode={this.handleContinueVerifyAdoptionMode}
          />
        )}
        {modalReviewAdoptionMode && (
          <ModalReviewDataAdoptionModeConnect
            open={modalReviewAdoptionMode}
            close={this.handleCloseReviewAdoptionMode}
            isProduct={buttonText == 'New Product'}
            selectedParent={selectedParentProduct}
            selectedParentCategory={selectedParentCategory}
            selectedProducts={selectedProducts || []}
            selectedCategories={selectedCategories || []}
          />
        )}
        {modalValidateProductsAdoptionMode && (
          <ModalValidateProductsAdoptionMode
            open={modalValidateProductsAdoptionMode}
            close={this.handleCloseValidateAdoptionMode}
            item={buttonText == 'New Product' ? 'product' : 'category'}
          />
        )}
      </div>
    )
  }
}

export const SearchBarConnect = connect(({ dispatch, masterCatalogReducer }) => ({
  dispatch,
  masterCatalogReducer,
}))(SearchBar)



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/SearchBar.js